import { keyframes, stylesheet } from 'typestyle';

import { colors, font } from '../../assets/styles';

const spinAnimation = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontWeight: font.weight.light,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: '-0.21px',
    textAlign: 'center',
  },
  subtitle: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
  },
  imageWrapper: {
    position: 'relative',
    margin: '35px 0',
  },
  imageContainer: {
    position: 'relative',
    background: colors.greyBackground,
    padding: 5,
    borderRadius: 100,
    overflow: 'hidden',
  },
  imageBadge: {
    position: 'absolute',
    zIndex: 2,
    bottom: 4,
    right: -12,
    height: 70,
    width: 70,
    background: 'red',
    borderRadius: 70,
    borderWidth: 6,
    borderColor: 'white',
    borderStyle: 'solid',
  },
  imageLoadingCircle: {
    position: 'absolute',
    zIndex: 1,
    top: -1,
    left: -1,
    width: 85,
    height: 85,
    backgroundImage:
      `radial-gradient(
        ${colors.primary},
        ${colors.greyBackground}
      )`,
    transformOrigin: 'bottom right',
  },
  imageLoadingCircleAnimation: {
    animationName: spinAnimation,
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  },
  imageOutline: {
    position: 'relative',
    zIndex: 2,
    background: colors.white,
    padding: 4,
    borderRadius: 100,
  },
  image: {
    position: 'relative',
    overflow: 'hidden',
    height: 150,
    width: 150,
    borderRadius: 100,
  },
});

export default styles;
